// Translations for the firestore collections.

// English 
export const EN = {
  "categories": "categories_en",
  "dishes": "dishes_en",
  "info": "info_en",
  "promo":"promo_en"
}

// Spanish 
export const ES = {
  "categories": "categories_es",
  "dishes": "dishes_es",
  "info": "info_es",
  "promo":"promo_es"
}

// Dutch 
export const NL = {
  "categories": "categories_nl",
  "dishes": "dishes_nl",
  "info": "info_nl",
  "promo":"promo_nl"
}

// German
export const DE = {
  "categories": "categories_de",
  "dishes": "dishes_de",
  "info": "info_de",
  "promo":"promo_de"
}

// French 
export const FR = {
  "categories": "categories_fr",
  "dishes": "dishes_fr",
  "info": "info_fr",
  "promo": "promo_fr"
}

// Swedish
export const SV = {
  "categories": "categories_sv",
  "dishes": "dishes_sv",
  "info": "info_sv",
  "promo": "promo_sv"
}


// Chinese
export const ZH = {
  "categories": "categories_zh",
  "dishes": "dishes_zh",
  "info": "info_zh",
  "promo": "promo_zh"
}


// Italian
export const IT = {
  "categories": "categories_it",
  "dishes": "dishes_it",
  "info": "info_it",
  "promo": "promo_it"
}

// Arabic
export const AR = {
  "categories": "categories_ar",
  "dishes": "dishes_ar",
  "info": "info_ar",
  "promo": "promo_ar"
}

// Portuguese
export const PT = {
  "categories": "categories_pt",
  "dishes": "dishes_pt",
  "info": "info_pt",
  "promo": "promo_pt"
}


// WEBPACK FOOTER //
// ./src/messages/firestoreTranslations.js